import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';
import { ConfirmationModalComponent } from 'src/app/shared-components/confirmation-modal/confirmation-modal.component';
import { AuthService } from 'src/app/_services/auth.service';
import { CatalogService } from 'src/app/_services/catalogs/catalog.service';
import { ResponsabilidadesOferta } from '../../egresado/responses/get-detalles-oferta-egr-response';
import { BeneficioOferta, ConocimientoOferta, DetallesContacto, HabilidadOferta, InsertOfertaTrabajoExternaRequest, ResponsabilidadOferta } from '../requests/insert-oferta-trabajo-externa-request';
import { DocenteService } from '../services/docente.service';

@Component({
  selector: 'app-doc-oferta-wizard',
  templateUrl: './doc-oferta-wizard.component.html',
  styleUrls: ['./doc-oferta-wizard.component.css']
})
export class DocOfertaWizardComponent implements OnInit{
  public basicColorBorderCollapse1 = false;
  public basicColorBorderCollapse2 = false;
  loadPage = false;
  showModal=false;

  currentUser;

  options = {
    minimize: false,
    reload: false,
    expand: true,
    close: false
  };

  file : any;

  _listaConocimientos = [];
  _listaHabilidades = [];
  _listaDivisiones = [];
  hablidadesFiltradas = [];
  conocimientosFiltradas = [];
  _listaAreas = [];

  habilidadesSeleccionadas = [];
  conocimientosSeleccionados = [];

  negotiateCompany = false;
  divisionSeleccionada;
  areaSeleccionada;

  stepOneForm: FormGroup;
  stepTwoForm: FormGroup;
  stepThreeForm: FormGroup;
  stepFourForm: FormGroup;
  stepFiveForm: FormGroup;

  formCounter=1;
  formCounterFour=1;
  public repeatList: FormArray;
  public repeatListFour : FormArray;

  todayDate = new Date().toLocaleString()

  modalities = ['Remota','Presencial','Híbrida'];

  public breadcrumb: any;

  constructor(private formBuilder: FormBuilder,
              private catalogService : CatalogService,
              private toast : ToastrService,
              private modalService: NgbModal,
              private docenteService : DocenteService,
              private router: Router,
              private authService : AuthService) { }

  async ngOnInit()
  {
    this.currentUser = this.authService.getProf();
    if(this.currentUser && this.currentUser.idUsuario>0)
    {
      this.setWizardForm();
      this.stepOneForm.get('experience').valueChanges.subscribe(value => {
        const division = this._listaDivisiones.find(d => d.idDivision === value);
        this.divisionSeleccionada = division ? division.descripcion : '';
      });
      this.stepOneForm.get('speciality').valueChanges.subscribe(value => {
        const area = this._listaAreas.find(d => d.idArea === value);
        this.areaSeleccionada = area ? area.descripcion : '';
      });

      await this.loadData();
      this.repeatList = this.stepThreeForm.get('repeatArray') as FormArray;
      this.repeatListFour = this.stepFourForm.get('repeatArrayFour') as FormArray;
      this.breadcrumb = {
        'mainlabel': 'Crear Nueva Oferta de Trabajo'
      };
    }
  }

  Validate() : boolean
  {
    if(this.stepOneForm.invalid || this.stepTwoForm.invalid || this.stepThreeForm.invalid || this.stepFourForm.invalid || this.stepFiveForm.invalid)
    {
      this.toast.error('Verifica que todos los datos sean correctos.','Error');
      return false;
    }
    if(this.habilidadesSeleccionadas.length<1)
    {
      this.toast.error('Es necesario seleccionar "al menos" una habilidad para el perfil que solicitas.','Error');
      return false;
    }
    if(this.conocimientosSeleccionados.length<1)
    {
      this.toast.error('Es necesario seleccionar "al menos" un conocimiento para el perfil que solicitas.','Error');
      return false;
    }
    return true;
  }

  async dataBinding() : Promise<any>
  {
    let insertOfertaExternaObject : InsertOfertaTrabajoExternaRequest = {} as InsertOfertaTrabajoExternaRequest;
    let habilidades : HabilidadOferta[] =[];
    let conocimientos : ConocimientoOferta[] =[];
    let responsabilidades : ResponsabilidadOferta[] =[];
    let beneficios : BeneficioOferta[] =[];
    let detallesContacto : DetallesContacto = {} as DetallesContacto;
    
    insertOfertaExternaObject.descripcionPuesto = this.f.occupation.value;
    insertOfertaExternaObject.idArea = this.f.speciality.value;

    this.habilidadesSeleccionadas.forEach(element=>
      {
        let newHabilidad : HabilidadOferta = {} as HabilidadOferta;
        newHabilidad.idHabilidad=element.idHabilidad;
        habilidades.push(newHabilidad);
      });
    this.conocimientosSeleccionados.forEach(element=>
      {
        let newConocimiento : ConocimientoOferta = {} as ConocimientoOferta;
        newConocimiento.idConocimiento=element.idConocimiento;
        conocimientos.push(newConocimiento);
      });

    this.repeatList.controls.forEach(element => 
        {
          let actualElement = element as FormGroup;
          if((actualElement.get('responsability').value!='') && actualElement.valid)
          {
            let item : ResponsabilidadesOferta = {} as ResponsabilidadesOferta;
            item.descripcion = actualElement.get('responsability').value;
            responsabilidades.push(item)
          }
      });

      if(!this.negotiateCompany)
      {
        this.repeatListFour.controls.forEach(element => 
          {
            let actualElement = element as FormGroup;
            if((actualElement.get('benefit').value!='') && actualElement.valid)
            {
              let item : BeneficioOferta = {} as BeneficioOferta;
              item.descripcion = actualElement.get('benefit').value;
              beneficios.push(item)
            }
        });
      }

      insertOfertaExternaObject.beneficios=beneficios;
      insertOfertaExternaObject.habilidades=habilidades;
      insertOfertaExternaObject.conocimientos=conocimientos;
      insertOfertaExternaObject.responsabilidades=responsabilidades;  
      insertOfertaExternaObject.periodoContrato = this.i.period.value;
      insertOfertaExternaObject.modalidad = this.i.modality.value;
      if((this.i.startTime.valid && this.i.startTime.value!='') && (this.i.endTime.valid && this.i.endTime.value!=''))
      insertOfertaExternaObject.horarioTrabajo=`De:${this.i.startTime.value} A:${this.i.endTime.value}`;
      else
      insertOfertaExternaObject.horarioTrabajo = 'No especificado';
      insertOfertaExternaObject.sueldoMinEstimado = this.i.minTax.value !='' ? this.i.minTax.value : 0;
      insertOfertaExternaObject.sueldoMaxEstimado = this.i.maxTax.value !='' ? this.i.maxTax.value : 0;
      insertOfertaExternaObject.lugar = this.i.direction.value;
      detallesContacto.imgUrl='';
      if(this.file)
      {
        const valueImg = await firstValueFrom(this.docenteService.subirFotografiaDetalle(this.file)); 
        if(valueImg.success)
        {
          detallesContacto.imgUrl = valueImg.result;
        }
        else
        {
          this.toast.error('Error al subir la fotografía','error');
          return null;
        }
      }

      detallesContacto.empresa=this.a.company.value;
      detallesContacto.actividadEmpresa=this.a.activity.value;
      detallesContacto.domicilio=this.a.direction.value;
      detallesContacto.CP=this.a.cp.value;
      detallesContacto.telefonos=this.a.phones.value;
      detallesContacto.correoEmpresa=this.a.email.value;
      detallesContacto.descripcionEmpresa=this.a.aboutCompany.value;
      detallesContacto.nombreResponsable=this.a.responsableName.value;
      detallesContacto.telefonoResponsable=this.a.responsablePhone.value;
      detallesContacto.correoResponsable=this.a.responsableEmail.value;

      insertOfertaExternaObject.detallesContacto=detallesContacto;
      insertOfertaExternaObject.idUsuario=this.currentUser.idUsuario;
      return insertOfertaExternaObject;  
  }


  get stepThreeFormGroup() {
    return this.stepThreeForm.get('repeatArray') as FormArray;
  }

  get stepFourFormGroup() {
    return this.stepFourForm.get('repeatArrayFour') as FormArray;
  }

  get f() {
    return this.stepOneForm.controls;
  }
  get i() {
    return this.stepTwoForm.controls;
  }

  get a(){
    return this.stepFiveForm.controls;
  }

  async SuccessModel() {
    if(!this.Validate())
      return;
    const modalRef = this.modalService.open(ConfirmationModalComponent,{ windowClass: 'animated fadeInUp',keyboard:false,backdrop: false });
    modalRef.componentInstance.title = 'Confirmación';
    modalRef.componentInstance.message = '';
    modalRef.result.then(async (result) => {
      if (result === 'accept') {
        // El usuario ha aceptado el modal
        try{
          const dataBinded = await this.dataBinding();
          if(!dataBinded)
            return;
          const result = await firstValueFrom(this.docenteService.insertOfertaTrabajoExterna(dataBinded));
          if(!result.success)
          {
            this.toast.error('No fue posible registrar la oferta. Inténtalo de nuevo.','Error');
            return;
          }
          this.toast.success('Un administrador la revisará eventualmente y de ser válida, será publicada.','Oferta Creada');
          this.router.navigate(['/docente/enRevision']);
        }
        catch (error)
        {
          this.toast.error('No fue posible registrar la oferta. Inténtalo de nuevo.','Error');
        }
        return;
      }
    }, (reason) => {
      // El usuario ha cerrado el modal sin hacer clic en ningún botón
    });
  }

  setWizardForm()
  {
    this.stepOneForm = this.formBuilder.group({
      occupation: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(80)] ),
      experience: new FormControl('', Validators.required),
      speciality: new FormControl('', Validators.required),
    });

    this.stepTwoForm = this.formBuilder.group({
      period: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(30)] ),
      modality: new FormControl('', Validators.required),
      direction: new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(150)]),
      startTime: new FormControl('', Validators.required),
      endTime: new FormControl('', Validators.required),
      minTax: new FormControl('',Validators.pattern(/^[0-9]+$/)),
      maxTax: new FormControl('',Validators.pattern(/^[0-9]+$/)),
    });

    this.stepFiveForm = this.formBuilder.group({
      company: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(100)] ),
      activity: new FormControl('', [Validators.required, Validators.minLength(5),Validators.maxLength(75)]),
      direction: new FormControl('', [Validators.required, Validators.minLength(10), Validators.maxLength(150)]),
      cp: new FormControl('', [Validators.required,Validators.minLength(5),Validators.maxLength(5)]),
      phones: new FormControl('', [Validators.required, Validators.minLength(5),Validators.maxLength(45)]),
      email: new FormControl('',[Validators.required,Validators.email,Validators.minLength(5),Validators.maxLength(85)]),
      aboutCompany: new FormControl('',[Validators.required, Validators.minLength(15), Validators.maxLength(500)]),
      responsableName: new FormControl('', [Validators.required,Validators.minLength(5),Validators.maxLength(85)] ),
      responsablePhone: new FormControl('', [Validators.required,Validators.minLength(10),Validators.maxLength(10)]),
      responsableEmail: new FormControl('', [Validators.required,Validators.email,,Validators.minLength(10),Validators.maxLength(85)]),
      // IMG 100
    });

    this.stepThreeForm = this.formBuilder.group({
      repeatArray: this.formBuilder.array([this.createRepeat()],Validators.required)
    });

    this.stepFourForm = this.formBuilder.group({
      negotiateCompany: new FormControl(),
      repeatArrayFour: this.formBuilder.array([this.createRepeatFour()])
    });
  }

  createRepeat(): FormGroup {
    return this.formBuilder.group({
      responsability: new FormControl('', [Validators.required,Validators.minLength(7), Validators.maxLength(500)]),
    });
  }

  createRepeatFour(): FormGroup {
    return this.formBuilder.group({
      benefit: new FormControl('', [Validators.minLength(5), Validators.maxLength(500)]),
    });
  }

  addRepeat() {
    let validationNumber=0;
    this.repeatList.controls.forEach(element => 
      {
        let actualElement = element as FormGroup;
        if((actualElement.get('responsability').value!='') && actualElement.valid)
        {
          if(validationNumber==0)
            validationNumber=0;
        }
        else
        {
          this.toast.warning('Debes completar la información solicitada antes de agregar un nuevo formulario.','Campos Incompletos');
          validationNumber=1;
        }
    });
    if(validationNumber==0) // validaciones por frontend
    {
      this.formCounter++;
      this.repeatList.push(this.createRepeat());
    }
  }

  addRepeatFour() {
    let validationNumber=0;
    this.repeatListFour.controls.forEach(element => 
      {
        let actualElement = element as FormGroup;
        if((actualElement.get('benefit').value!='') && actualElement.valid)
        {
          if(validationNumber==0)
            validationNumber=0;
        }
        else
        {
          this.toast.warning('Debes completar la información solicitada antes de agregar un nuevo formulario.','Campos Incompletos');
          validationNumber=1;
        }
    });
    if(validationNumber==0) // validaciones por frontend
    {
      this.formCounterFour++;
      this.repeatListFour.push(this.createRepeatFour());
    }
  }

  removeRepeat(index) { // validaciones por frontend
    if(this.formCounter>1)
    {
      this.formCounter--;
      this.repeatList.removeAt(index);
    }
  }

  removeRepeatFour(index) { // validaciones por frontend
    if(this.formCounterFour>1)
    {
      this.formCounterFour--;
      this.repeatListFour.removeAt(index);
    }
  }

  async LoadConocimientos() : Promise<boolean>
  {
    try 
    {
      const data = await firstValueFrom(this.catalogService.getConocimientos());
      if(data && data.length>0)
      {
        this._listaConocimientos = data;
        this.conocimientosFiltradas = data.sort(() => 0.5 - Math.random()).slice(0, 10);
        return true;
      }
    } 
    catch (error) {
      // manejar el error
    }
      return false;
  }

  async LoadHabilidades(): Promise<boolean> 
  {
    try 
    {
      const data = await firstValueFrom(this.catalogService.getHabilidades());
      if (data && data.length > 0) 
      {
        this._listaHabilidades = data;
        this.hablidadesFiltradas = data.sort(() => 0.5 - Math.random()).slice(0, 10);
        return true;
      }
    } 
    catch (error) {
      // manejar el error
    }
      return false;
  }


  async LoadDivisiones() : Promise<boolean>
  {
    try 
    {
      const data = await firstValueFrom(this.catalogService.getDivisiones());
      if(data && data.length>0)
      {
        this._listaDivisiones = data;
        if(this.loadAreas(this._listaDivisiones[0]?.idDivision))
        {
          this.stepOneForm.get('experience').setValue(this._listaDivisiones[0]?.idDivision);
          return true;
        }
      }
    } 
    catch (error) {
      // manejar el error
    }
      return false;
  }

  BuscarHabilidades(term: string) {
    if (term.length >= 1) {
      this.hablidadesFiltradas = 
      this._listaHabilidades.filter(
        elemento => 
        (elemento.descripcion.toLowerCase().includes(term.toLowerCase())
        && elemento.banderaEliminar==false)
      );
    }
  }

  BuscarConocimientos(term: string) {
    if (term.length >= 1) {
      this.conocimientosFiltradas = 
      this._listaConocimientos.filter(
        elemento => 
        (elemento.descripcion.toLowerCase().includes(term.toLowerCase())
        && elemento.banderaEliminar==false)
      );
    }
  }

  async loadAreas(idDivision: number) : Promise<boolean>
  {
    try 
    {
      const data = await firstValueFrom(this.catalogService.getAreasUTPDivision(idDivision));
      if(data && data.length>0)
      {
        this._listaAreas = data;
        if(this._listaAreas && this._listaAreas.length>0)
        {
          this.loadAreas(this._listaAreas[0]?.idArea);
          this.stepOneForm.get('speciality').setValue(this._listaAreas[0]?.idArea);
          return true;
        }
      }
    } 
    catch (error) {
      // manejar el error
    }
      return false;
  }

  async loadData()
  {
    let habLoaded =  await this.LoadHabilidades();
    let conLoaded = await this.LoadConocimientos();
    let divloaded = await this.LoadDivisiones();
    if(!habLoaded || !conLoaded || !divloaded)
    {
      this.toast.error('No se cargaron los datos correctamente. Inténtalo de nuevo.','Error de conexión');
      return;
    }
    this.loadPage=true;
  }


    onAddHabilidad(event) {
      // this.habilidadesSeleccionadas.push(event);
    }

    onRemoveHabilidad(item: any) {
      // const index=this.habilidadesSeleccionadas.findIndex(d=>d.idHabilidad==item.idHabilidad);
      // this.habilidadesSeleccionadas.splice(index,1);
    }  

    onAddConocimiento(event) {
      // this.conocimientosSeleccionados.push(event);
    }

    onRemoveConocimiento(item: any) {
      // const index=this.conocimientosSeleccionados.findIndex(d=>d.idConocimiento==item.idConocimiento);
      // this.conocimientosSeleccionados.splice(index,1);
    }

    onFileSelected(event: any) {
      const file: File = event.target.files[0];
    
      // Verificar si es una imagen
      if (!file.type.startsWith('image/')) {
        this.toast.error('El archivo seleccionado no es una imagen','error');
        return;
      }
    
      // Verificar si no pesa más de 2MB
      if (file.size > 2000000) {
        this.toast.error('El archivo seleccionado pesa más de 2MB','error');
        return;
      }
    
      // Si pasa las verificaciones, se puede proceder a cargar la imagen
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.file=file;
      };
    }  
}
